import { render, staticRenderFns } from "./MaterialVideos.vue?vue&type=template&id=233d7fa0"
import script from "./MaterialVideos.vue?vue&type=script&lang=js"
export * from "./MaterialVideos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports